import FAQ from "../pages/faq/faq";

export const NAVIGATION_PATH = Object.freeze({
    HOME: '/',
    ADMIN: '/admin',
    CHANGELOG: '/changelog',
    FAQ: '/faq',
    TERMS_AND_CONDITIONS: '/terms-and-conditions',
    CRM_MANAGEMENT: '/contract-management',
    DENIED: "/denied",
    LOGIN_PATH: '/login',
    PROFILE: "/profile",
    SITE_ROOT: '/sites',
    USERS: '/users',
    WILDCARD: "*",
    PASSWORD_RESET: '/reset-password',
    REQUEST_PASSWORD_RESET: '/request-password-reset',


  ALERTS: "alerts",
  COMMISSIONING: "commissioning",
  DASHBOARD: "dashboard",
  DEVICES: "devices",
  GENERAL: "general",
  LOG: "log",
  FINANCIAL: "financial",
  METERING: "metering",
  INSTALLATION: "installation",
  SCHEMATIC: "schematic",
  SMARTBOXES: "smartboxes",
  STATISTICS: "statistics",
  NEW_INSTALLATION: "new-installation",
});

